
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/pickup/ford-f-150",
      function () {
        return require("private-next-pages/tyres/pickup/ford-f-150.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/pickup/ford-f-150"])
      });
    }
  